import { Stack } from "@mui/system";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import PauseCircleOutlinedIcon from "@mui/icons-material/PauseCircleOutlined";

type StatusType =
  | "succeeded"
  | "failed"
  | "running"
  | "paused"
  | "active"
  | "inactive";

export const STATUS_CONFIG: Record<
  StatusType,
  {
    label: string;
    color: string;
    bg: string;
    border: string;
    icon: JSX.Element;
  }
> = {
  succeeded: {
    label: "Succeeded",
    color: "#1E4620",
    bg: "#EDF7ED",
    border: "#2E7D3280",
    icon: <CheckCircleOutlinedIcon fontSize="small" />,
  },
  failed: {
    label: "Failed",
    color: "#5F2120",
    bg: "#FDEDED",
    border: "#D32F2F80",
    icon: <CancelOutlinedIcon fontSize="small" />,
  },
  running: {
    label: "Running",
    color: "#7B1FA2",
    bg: "#9C27B01F",
    border: "#9C27B080",
    icon: <AutorenewIcon fontSize="small" />,
  },
  paused: {
    label: "Paused",
    color: "#00000099",
    bg: "#0000001F",
    border: "#9E9E9E",
    icon: <PauseCircleOutlinedIcon fontSize="small" />,
  },
  active: {
    label: "Active",
    color: "#1E4620",
    bg: "#EDF7ED",
    border: "#2E7D3280",
    icon: <CheckCircleOutlinedIcon fontSize="small" />,
  },
  inactive: {
    label: "Inactive",
    color: "#5F2120",
    bg: "#FDEDED",
    border: "#D32F2F80",
    icon: <CancelOutlinedIcon fontSize="small" />,
  },
};

const StatusChip = ({ status }: { status?: string }) => {
  const key = status?.toLowerCase();

  if (!key || !(key in STATUS_CONFIG)) {
    return "";
  }

  const config = STATUS_CONFIG[key as StatusType];

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      sx={{
        px: 0.5,
        py: 0.3,
        borderRadius: "4px",
        backgroundColor: config.bg,
        border: `1px solid ${config.border}`,
        width: "fit-content",
      }}
    >
      <span style={{ display: "flex", color: config.color }}>
        {config.icon}
      </span>
      <span
        style={{
          fontSize: "13px",
          fontWeight: 500,
          color: config.color,
        }}
      >
        {config.label}
      </span>
    </Stack>
  );
};

export default StatusChip;
